import { Button, message, Spin, Table, Card, Input, Tag } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import { use, useEffect, useState } from "react";
// import { HEADERS_BASIC } from "../../API/apiUrlsGarfe";
import axios, { all } from "axios";
import ModalDetailContno from "./modal/modalDetailContno";
import { API_MAIN_ALL_CONTRACT, HEADERS_BASIC } from "../../API/apiUrlsNew";



const Main_All_Contract = () => {
    const [dataAll, setDataAll] = useState([]);
    const [dataArray, setDataArray] = useState([]);
    const ROLE_ID = parseInt(localStorage.getItem("ROLE_ID"), 10);
    const USER_ID = parseInt(localStorage.getItem("USER_ID"), 10);
    const [dataRrcoed, setDataRrecord] = useState();
    const [loading, setLoading] = useState(false);
    const [modalDetail, setModalDetail] = useState(false);


    useEffect(() => {
        loadData();
    }, []);


    const loadData = async () => {
        setLoading(true);
        let data = {
            ROLE_ID: ROLE_ID,
            USER_ID: USER_ID,

        }
        await axios.post(API_MAIN_ALL_CONTRACT, data, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {

                    setDataAll(res.data);
                    setDataArray(res.data)
                    setLoading(false);
                    // message.success("โหลดข้อมูลสำเร็จ");
                }
            })
            .catch((err) => {
                setLoading(false);
                message.error("โหลดข้อมูลไม่สำเร็จ !! ");
                console.log(err);
            });
    }

    const handleButtonDetail = (data) => {
        console.log("dataaaaa", data);

        setDataRrecord(data)
        setModalDetail(true);
    }

    const handleSearch = (value) => {
        const filtered = dataAll.filter((item) =>
            item.CONTNO?.toLowerCase().includes(value.toLowerCase())
        );

        setDataArray(filtered);
    };

    const listLoneType = {
        HIRE_PURCASE: [1, "ฟ้องเช่าซื้อ"],
        MORTGAGE: [2, "ฟ้องเงินกู้(จดจำนอง)"],
        GENERAL_LOAN: [3, "ฟ้องเงินกู้(กู้ทั่วไป)"],
        CAR_LOAN: [4, "ฟ้องเงินกู้(คู่มือรถ)"],
        DEFFERENCE: [6, "ฟ้องส่วนต่าง"],
        EMBEZZLEMENT: [7, "ฟ้องอาญา(ยักยอกทรัพย์)"],
        FRAUDULENT: [8, "ฟ้องอาญา(ฉ้อโกง)"],
        HIRE_PURCASE_EMBEZZLEMENT: [8, "ฟ้องอาญา(ยักยอกทรัพย์),ฟ้องเช่าซื้อ"],
        MORTGAGE_EMBEZZLEMENT: [9, "ฟ้องอาญา(ยักยอกทรัพย์),ฟ้องเงินกู้"],
    };

    // const loanTypeMap = Object.fromEntries(
    //     Object.values(listLoneType).map(([id, name]) => [id, name])
    // );

    const lawTypeColor = {
        1: "blue",
        2: "green",
        3: "purple",
        4: "cyan",
        6: "geekblue",
        7: "red",
        8: "volcano",
        9: "magenta",
    };


    const columns = [
        {
            title: "ลำดับ",
            dataIndex: "no",
            key: "no",
            width: 80,
            align: "center",
            render: (_, __, index) => index + 1,
        },
        {
            title: "เลขสัญญา",
            dataIndex: "contractNo",
            key: "contractNo",
            align: "center",
            render: (_, record) => <b style={{ color: 'blue' }}>{record.CONTNO}</b>,
        },
        {
            title: "ชื่อลูกค้า",
            dataIndex: "customerName",
            key: "customerName",
            render: (_, record) => <b>{record.FULLNAME}</b>,
        },
        {
            title: "ประเภทการฟ้อง",
            dataIndex: "LAW_TYPE_ID",
            key: "LAW_TYPE_ID",
            align: "center",
            render: (_, record) => {
                const type = Object.values(listLoneType).find(
                    ([id]) => id === record.LAW_TYPE_ID
                );

                const color = lawTypeColor[record.LAW_TYPE_ID] || "orange";

                return (
                    <Tag color={color}>
                        {type ? type[1] : "ยังไม่มีข้อมูลการฟ้อง"}
                    </Tag>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "status",
            key: "status",
            align: "center",
            render: (_, record) => (
                <>
                    <Button
                        type="primary"
                        icon={<EyeOutlined />}
                        onClick={() => handleButtonDetail(record)}
                        style={{
                            borderRadius: 8,
                            fontWeight: 500,
                        }}
                    >
                        รายละเอียด
                    </Button>
                </>
            ),
        },
    ];


    return (
        <>
            {/* <div>สัญญาทั้งหมด</div> */}

            <Card
                title="ข้อมูลสัญญาทั้งหมด"
                style={{ borderRadius: 12 }}
                bodyStyle={{ padding: 16 }}
            >
                <Spin spinning={loading} size="large" tip="Loading...">

                    {/* Header */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            marginBottom: 16,
                        }}
                    >
                        <Input
                            placeholder="ค้นหาสัญญา..."
                            allowClear
                            style={{ width: 300, height: 40 }}
                            size="large"
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                    </div>

                    {/* Table */}
                    <Table
                        columns={columns}
                        dataSource={dataArray}
                        rowKey={(record) => record.id || record.CONTNO}
                        size="middle"
                        bordered
                        pagination={{
                            pageSize: 10,
                            showSizeChanger: true,
                        }}
                        scroll={{ x: "max-content" }}
                    />

                </Spin>
            </Card>

            {
                modalDetail && (
                    <ModalDetailContno
                        open={modalDetail}
                        close={() => setModalDetail(false)}
                        dataRecord={dataRrcoed}
                    />
                )
            }
        </>
    );

}

const MainAllContract = MotionHoc(Main_All_Contract);
export default MainAllContract;